<template>
    <Header ueberschrift="GW-Logistik" />
    <div id="gw-l">
        <h2>MR:</h2>
        <p>4x Handscheinwerfer</p>
        <p>4x HRT's</p>
        <p>2x Einweghandschuhe</p>
        <p>Rettungsrucksack</p>
        <p>6x Warnwesten</p>
        <p>Tablet</p>
        <br>
        <h2>MR unter Sitzkasten:</h2>
        <p>Rettungstuch</p>
        <p>4x Leuchten für Verkehrsleitkegel</p>
        <p>3x Warndreieck (für Fahrzeug)</p>
        <p>3x Warnleuchten (für Fahrzeug)</p>
        <p>Wagenheber</p>
        <p>Adapterkabel für Batterieladegerät</p>
        <br>
        <h2>G1:</h2>
        <p>Kettensäge mit Kanister</p>
        <p>2x Schnittschutzkleidung mit Helm</p>
        <p>Schublade Handwerkzeug (Bolzenschneider, Holzaxt, Bügelsäte, Spaten, Halligan-Tool, 2x Besen, 2x Schaufel)</p>
        <p>1x Arbeitsleine</p>
        <p>4x Rettungsleine</p>
        <p>Rettungsplattform</p>
        <p>Stabfast XL</p>
        <p>Stromerzeuger</p>
        <p>10l Kanister</p>
        <p>Stativ Licht</p>
        <p>2x Scheinwerfer 1000W auf Brücke</p>
        <p>Deltabox</p>
        <p>Werkzeugkasten</p>
        <p>2x Kabeltrommel</p>
        <br>
        <h2>G2:</h2>
        <p>Trennschleifer groß</p>
        <p>Trennschleifer klein</p>
        <p>Krankentrage</p>
        <p>Koffer 6x Rundumleuchten</p>
        <p>5x Verkehrsleitkegel</p>
        <p>Tigersäge</p>
        <p>Glasmanagement</p>
        <p>2x Kisten Unterbausystem</p>
        <p>Rettungszylinder groß</p>
        <p>Rettungszylinder klein</p>
        <p>2x Faltsignal</p>
        <p>1x Druckluftanschluss</p>
        <p>Hydraulikgerät</p>
        <p>Spreizer</p>
        <p>Schneidegerät</p>
        <p>Bereitstellungsplane</p>
        <p>Schwelleraufsatz</p>
        <p>Rettungsplattform</p>
        <br>
        <h2>Kofferaufbau / Alkoven:</h2>
        <p>Bierzeltgarnitur</p>
        <p>Multifunktionsleiter</p>
        <p>2x Schuttmulden (Metall)</p>
        <p>Kiste Druckluftzubehör</p>
        <p>3x Kisten div. Kleinteile</p>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'MTA2',
    components: {
        Header,
        Footer
    },
    data() {
        return {

        }
    },
    methods: {

    },
    created() {
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
#gw-l{
    display: block !important;
    position:absolute !important;
    height:auto !important;
    bottom:0 !important;
    top:0 !important;
    left:0 !important;
    right:0 !important;
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 4.5rem;
    height: 72vh;
    overflow-y: scroll;
    background-color: white;
}
</style>